module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('splash', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.splash),
      expression: "splash"
    }],
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.startAnimation($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.splash),
      expression: "!splash"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticStyle: {
      "background": "black"
    },
    attrs: {
      "id": "video",
      "autoplay": "",
      "controls": "true",
      "width": "100%",
      "height": "100%",
      "src": _vm.episode.animation[_vm.key].file,
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-animation-text"
  }, [_vm._v(" " + _vm._s(_vm.episode.animation[_vm.key].text) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "intro-animation-image-container"
  }, [_c('div', {
    staticClass: "intro-animation-container"
  }, [_c('div', {
    staticClass: "back-anim-container"
  }, [_c('img', {
    staticClass: "intro-animation-image intro-animation-image-back",
    attrs: {
      "src": _vm.episode.animation[_vm.key].file
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "front-anim-container"
  }, [_c('img', {
    staticClass: "intro-animation-image intro-animation-image-front",
    attrs: {
      "src": _vm.episode.animation[_vm.prevKey].file
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "intro-animation-text"
  }, [_vm._v(" " + _vm._s(_vm.episode.animation[_vm.key].text) + " ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1463f1ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Intro.vue
// module id = 113
// module chunks = 1